<template>
  <b-container class="pl-0" fluid>
    <b-row>
      <b-col xl="9">
        <FaultEventsList :min-date="formatMinDate(visnetHubCreatedAt)" />
      </b-col>
      <b-col class="px-xl-0" xl="3">
        <FaultEventData />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <FaultEventsWaveformsList :min-date="formatMinDate(visnetHubCreatedAt)" />
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import FaultMixins from '@/components/mixins/fault/fault-mixin';
import FaultEventsList from '@/components/substations/visnet-hubs/main-view/fault/fault-events';
import FaultEventData from '@/components/substations/visnet-hubs/main-view/fault/fault-events-data';
import FaultEventsWaveformsList from '@/components/substations/visnet-hubs/main-view/fault/fault-events-waveforms-list';

export default {
  name: 'FaultEventslist',
  components: { FaultEventsList, FaultEventData, FaultEventsWaveformsList },
  mixins: [FaultMixins],
  computed: {
    ...mapState({
      visnetHubCreatedAt: state => state.substationVisnetHub.visnetHub.createdAt
    })
  }
};
</script>
